import {
  Col,
  Row,
  VertSkeleton,
  VertTypography,
} from '@vertem-core/vertice-ds';
import SelectOrderBy from 'components/SelectOrderBy/SelectOrderBy';
import React from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

const SearchTopbar = ({
  title,
  onChange,
  value,
  staticData,
  error,
  titleVendor,
  productLabel = 'produtos',
  disableOrderFilter
}) => {
  const Search = useSelector(({ Search: data }) => data);

  return (
    <Row
      justify="center"
      align="middle"
      className="vert-category vert-category-title margin-bottom-big"
      gutter={8}
    >
      <Col className="vert-category vert-category-title-label col">
        {(() => {
          if (error) {
            return (
              <VertTypography.Title level={2} className="margin-bottom-none">
                Nenhum resultado para esta consulta.
              </VertTypography.Title>
            );
          }

          if (title) {
            return (
              <VertTypography.Title level={2} className="margin-bottom-none">
                Principais resultados para “{title}”
              </VertTypography.Title>
            );
          }

          if (titleVendor == 'Loja' || isEmpty(titleVendor)) {
            return (
              <VertTypography.Title level={2} className="margin-bottom-none">
                Principais resultados
              </VertTypography.Title>
            );
          }
          return (
            <VertTypography.Title level={2} className="margin-bottom-none">
              Principais resultados para “{titleVendor}”
            </VertTypography.Title>
          );
        })()}
        {(() => {
          const Data = staticData ? staticData : Search.data;
          if (!Data && !error)
            return (
              <VertSkeleton title={{ width: '280px' }} active paragraph={0} />
            );
          const { totalRowCount } = !error ? Data : { totalRowCount: 0 };
          return (
            <VertTypography.Paragraph className="margin-bottom-none">
              {totalRowCount} { productLabel } encontrados
            </VertTypography.Paragraph>
          );
        })()}
      </Col>
      {!disableOrderFilter && (
          <MediaQuery minWidth={769}>
            <SelectOrderBy valueSort={value} onChange={onChange} />
          </MediaQuery>
      )}
    </Row>
  );
};


SearchTopbar.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  withoutTitle: PropTypes.bool,
  productLabel: PropTypes.string,
  staticData: PropTypes.object,
  disableOrderFilter: PropTypes.bool,
};

export default SearchTopbar;
